import { handleErrors } from './AssetController'
import { getCoreServiceFetchOptions } from './CoreServiceController'
import { getSocialServiceHeaders } from './SocialServiceController'

/**
 * @todo Unused
 * @param {*} id 
 * @returns 
 */
export const approveAlbum = async (id) => {
  return fetch(`${process.env.REACT_APP_CORE_SERVICE}admin/approve/${id}`,
    getCoreServiceFetchOptions('GET'))
    .then(handleErrors)
    .then((res) => res.json())
    .then((updatedAlbum) => {
      return updatedAlbum
    })
}

export const approveMessage = async (messageId, approval, approvalReason) => {
  return fetch(`${process.env.REACT_APP_SOCIAL_SERVICE}admin/approveMessage/${messageId}/${approval}/${approvalReason}`, {
    method: 'GET',
    headers: getSocialServiceHeaders()
  })
    .then(handleErrors)
    .then((response) => {
      return response
    })
}

export const listPendingApprovals = async (start, count) => {
  const url = `${process.env.REACT_APP_SOCIAL_SERVICE}admin/listPendingApprovals/${start}/${count}`
  return fetch(url, {
    method: 'GET',
    headers: getSocialServiceHeaders()
  })
    .then(handleErrors)
    .then((res) => res.json())
    .then((approvals) => {
      return approvals
    })
}

